/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/style-prop-object */
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/doctorcard.css";

const Map = () => {
  return (
    <>
      <Navbar />
      <div className="card mx-auto my-6">
        <h1 className="text-2xl mx-auto font-semibold">
          <a href="https://dmc.gov.bd/"> Dhaka Medical College</a>
        </h1>
        <div
          style={{
            margin: "auto",
            padding: "20px",
            border: "1px solid green",
            borderRadius: "22px",
          }}
        >
          <iframe
            title="Embedded Content"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.5987774457253!2d90.39500577575205!3d23.72601788971118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8e6474187cf%3A0xb3d3783755659522!2sDhaka%20Medical%20College%20Hospital!5e0!3m2!1sen!2sbd!4v1692262724023!5m2!1sen!2sbd"
            width="600"
            height="450"
          ></iframe>
        </div>
      </div>
      <div className="card mx-auto my-6">
        <h1 className="text-2xl mx-auto font-semibold">
          <a href="https://bsmmu.ac.bd/">
            Bangabandhu Sheikh Mujib Medical University Hospital
          </a>
        </h1>
        <div
          style={{
            margin: "auto",
            padding: "20px",
            border: "1px solid green",
            borderRadius: "22px",
          }}
        >
          <iframe
            title="Embedded Content"
            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3652.2332213579707!2d90.39198177575233!3d23.739061339210725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1spg%20hosppital!5e0!3m2!1sen!2sbd!4v1692266165873!5m2!1sen!2sbd"
            width="600"
            height="450"
          ></iframe>
        </div>
      </div>
      <div className="card mx-auto my-6">
        <h1 className="text-2xl mx-auto font-semibold">
          <a href="http://www.mumc.gov.bd/">
            {" "}
            Mugda Medical College and Hospital
          </a>
        </h1>
        <div
          style={{
            margin: "auto",
            padding: "20px",
            border: "1px solid green",
            borderRadius: "22px",
          }}
        >
          <iframe
            title="Embedded Content"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.422906922118!2d90.4275132757522!3d23.732293989470456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b84739a83751%3A0x618730d695dcce07!2sMugda%20Medical%20College%20and%20Hospital!5e0!3m2!1sen!2sbd!4v1692266408516!5m2!1sen!2sbd"
            width="600"
            height="450"
          ></iframe>
        </div>
      </div>
      <div className="card mx-auto my-6">
        <h1 className="text-2xl mx-auto font-semibold">
          <a href="https://dmc.gov.bd/">
            {" "}
            Sir Salimullah Medical College Mitford Hospital
          </a>
        </h1>
        <div
          style={{
            margin: "auto",
            padding: "20px",
            border: "1px solid green",
            borderRadius: "22px",
          }}
        >
          <iframe
            title="Embedded Content"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3653.013789837268!2d90.3986757757517!3d23.71120159027939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b91cf294d4d5%3A0xdb324ec1fa918631!2sSir%20Salimullah%20Medical%20College%20Mitford%20Hospital!5e0!3m2!1sen!2sbd!4v1692266532057!5m2!1sen!2sbd"
            width="600"
            height="450"
          ></iframe>
        </div>
      </div>
      <div className="card mx-auto my-6 font-semibold">
        <h1 className="text-2xl mx-auto">
          <a href="https://labaidgroup.com/specialized">
            LABAID Specialized Hospital
          </a>
        </h1>
        <div
          style={{
            margin: "auto",
            padding: "20px",
            border: "1px solid green",
            borderRadius: "22px",
          }}
        >
          <iframe
            title="Embedded Content"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.1466955352453!2d90.38041907575241!3d23.742147689092402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8b7a02be491%3A0x45a9f97c4d06d4f9!2sLABAID%20Specialized%20Hospital!5e0!3m2!1sen!2sbd!4v1692266996633!5m2!1sen!2sbd"
            width="600"
            height="450"
          ></iframe>
        </div>
      </div>
      <div className="card mx-auto my-6 font-semibold">
        <h1 className="text-2xl mx-auto">
          <a href="https://www.ibnsinatrust.com/">
            Ibn Sina Diagnostic and Imaging Center
          </a>
        </h1>
        <div
          style={{
            margin: "auto",
            padding: "20px",
            border: "1px solid green",
            borderRadius: "22px",
          }}
        >
          <iframe
            title="Embedded Content"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.056041407177!2d90.36970697575249!3d23.74538088896824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755bf4c7c2d90a9%3A0x26436b1b9dcd741e!2sIbn%20Sina%20Diagnostic%20and%20Imaging%20Center%20(Dhanmondi%209A)!5e0!3m2!1sen!2sbd!4v1692267395964!5m2!1sen!2sbd"
            width="600"
            height="450"
          ></iframe>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Map;
